/* External */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/* Storage */
import { selectScheduleListByIdsList } from '../storage/schedules';

/* Utils */
import { PROVIDERS } from '../utils/constants';

export default function useChannelSchedules(channel) {
  const schedulesList = channel?.schedules.map((schedule) => `${schedule}-${channel?.sourceProvider ?? PROVIDERS.VRIO}`);

  const channelSchedulesSelector = useMemo(
    () => selectScheduleListByIdsList(schedulesList?.toList()),
    [schedulesList],
  );
  return useSelector(channelSchedulesSelector);
}
